export class EventDeleteLocations {
  eventId: number;
  unitId: number;

}



// WEBPACK FOOTER //
// ./src/app/core/models/event-delete-locations.ts